<template>
  <div class="wrap">
    <canvas id="rainCanvas" aria-hidden="true"></canvas>
    <div class="coupon-instruction" id="coupon-instruction" v-if="!isClicked">Ayoo,
      <span class="highlight">Klik & Tangkap</span>
      KUPON JAJAN mu!
    </div>
    <div id="rainfield" class="rainfield" aria-label="Area hujan kupon"></div>
    <div class="modal" id="modal">
      <div class="kupon-gosok-instructions" v-if="isModalShown">
        <span id="title">SELAMAT,</span><br>
        <span id="title-2">KAMU DAPAT KUPON JAJAN!</span><br>
        <span id="title-3">KLAIM SEKARANG!</span>
      </div>
      <div class="card" role="dialog" aria-modal="true" aria-labelledby="ttl">
        <div id="codeBox" class="codebox" aria-live="polite" v-if="!isRedirect">{{ code }}</div>
        <div id="codeBox" class="codebox text" aria-live="polite" v-if="isRedirect">Menghubungkan Anda ke Telkomsel…</div>
        <div class="countdown-container">
          <span class="countdown-text">Hangus dalam </span>
          <span class="countdown-timer" id="countdownTimer">05:00</span>
        </div>
        <div class="actions">
          <button type="button" class="btn" id="redemptionWebOptIn" @click="submitCode(code)">SALIN &amp; KLAIM DI SINI
            <span aria-hidden="true">&rsaquo;</span></button>
        </div>
      </div>
    </div>
    <div id="confetti" class="confetti" aria-hidden="true"></div>
  </div>
</template>
<script>
import { global } from "../utils";
import { event } from "vue-gtag";
import { Api } from "../services";
import config from "../utils/config";
import { useHead } from '@vueuse/head'

export default {
  name: "HujanKupon",
  setup() {
    const css = [
      'css/scratch.css',
      'css/hujan.css',
      'css/modal.css',
    ];

    const cssLink = css.map(src => ({
      rel: 'stylesheet',
      href: `${process.env.BASE_URL}${src}`,
    }))

    useHead({
      link: [
        ...cssLink
      ]
    })
  },
  data() {
    return {
      hasClaimed: false,
      limitOneClaim: true,
      activeCoupons: 0,
      spawnTimer: null,
      USED_CODES: new Set(),
      lastClickedCoupon: null,
      code: "??????",
      isClicked: false,
      cw: 0,
      ch: 0,
      rainCanvas: null,
      ctx: null,
      drops: [],
      rafId: null,
      forceLite: false,
      autoLite: false,
      isRedirect: false,
      isModalShown: false,
    };
  },
  mounted() {
    this.code = global.generateCodeKuponJajan();
    this.$nextTick(() => {
      this.initRain();

      window.addEventListener("click", (e) => {
        const modal = document.getElementById("modal");
        const isModalShown = modal && modal.classList.contains("show");
        const isCoupon = e.target.closest(".coupon");
        this.isModalShown = true;
        if (!isModalShown && !isCoupon) {
          this.sendGtag(1);
          this.vibrate(1);
          this.createFallingSplash(e.clientX, e.clientY);
        }
      });
    });
  },
  beforeUnmount() {
    this.stopRain();
    cancelAnimationFrame(this.rafId);
    window.removeEventListener("resize", this.setupRainCanvas);
  },
  methods: {
    vibrate(t) {
      if ("vibrate" in navigator) {
        if (t == 1) {
          navigator.vibrate([60, 80, 40, 100, 30]);
        } else {
          navigator.vibrate([200, 20, 750]);
        }
      } else {
        console.log("Vibration API not supported on this device/browser");
      }
    },
    countdown() {
      window.countdownTimer = null;
      window.timeLeft = config.timer;
      const timerElement = document.getElementById('countdownTimer');
      window.countdownTimer = setInterval(function () {
        const minutes = Math.floor(window.timeLeft / 60);
        const seconds = window.timeLeft % 60;

        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        timerElement.textContent = formattedTime;

        if (window.timeLeft <= 60) {
          timerElement.style.color = '#FFF';
          timerElement.style.fontWeight = 'bold';
        }

        if (window.timeLeft <= 0) {
          clearInterval(window.countdownTimer);
          timerElement.textContent = 'Sudah Hangus';
          timerElement.style.color = '#FFF';
          timerElement.style.fontWeight = 'bold';

          const countdownTextElement = document.querySelector('.countdown-text');
          if (countdownTextElement) {
            countdownTextElement.textContent = '';
          }
          return;
        }

        window.timeLeft--;
      }, 1000);
    },
    sendGtag(type) {
      if (type == 0) event("Tangkap Kupon - HK", {});
      else if (type == 1) event("Failed - Tangkap Kupon - HK", {});
      else if (type == 2) event("Success - Call WebOptIn - HK", {});
      else if (type == 3) event("Failed - Send Kode to API - HK", {});
    },
    async submitCode(code) {
      this.isRedirect = true;

      try {
        await navigator.clipboard.writeText(code);
      } catch (err) {
        console.error("Copy failed:", err);
      }

      Api.submitCode(code)
        .then((data) => {
          if (data.data.success == 1) this.sendGtag(2);
          else this.sendGtag(3);
          if (this.$route.path === '/tangkap-tukar') {
            global.portalRedirect(config.kjw_url, code, 1500)
          } else {
            global.portalRedirect(config.idw_url, code, 1500)
          }
        })
        .catch((err) => console.log(err));
    },
    initRain() {
      const MAX_ACTIVE_COUPONS = 10;
      const SPAWN_INTERVAL_MS = 220;
      const FALL_MIN_S = 2;
      const FALL_MAX_S = 3;
      const ROT_RANGE_DEG = 260;

      const rainfield = document.getElementById("rainfield");
      const modal = document.getElementById("modal");
      const codeBox = document.getElementById("codeBox");
      const confettiWrap = document.getElementById("confetti");

      const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
      const rand = (min, max) => min + Math.random() * (max - min);

      this.rainCanvas = document.getElementById("rainCanvas");
      if (!this.rainCanvas) {
        console.error("rainCanvas not found in DOM");
        return;
      }

      this.ctx = this.rainCanvas.getContext("2d");
      if (!this.ctx) {
        console.error("Cannot get 2D context for rainCanvas");
        return;
      }

      const devMem = navigator.deviceMemory || 4;
      const prefersReduced =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (devMem <= 2 || prefersReduced) this.autoLite = true;

      const spawnCoupon = () => {
        if (this.activeCoupons >= MAX_ACTIVE_COUPONS) return;

        const c = document.createElement("div");
        c.className = "coupon";
        c.setAttribute("role", "button");

        const vw = window.innerWidth;
        c.style.left = `${clamp(Math.random() * (vw - 120), 4, vw - 124)}px`;

        const dur = rand(FALL_MIN_S, FALL_MAX_S);
        const delay = Math.random() * 0.35;
        const rotStart = rand(-ROT_RANGE_DEG / 2, ROT_RANGE_DEG / 2);
        const rotEnd = rotStart + rand(-360, 360);
        c.style.setProperty("--rotStart", `${rotStart}deg`);
        c.style.setProperty("--rotEnd", `${rotEnd}deg`);
        c.style.animation = `fall ${dur}s linear ${delay}s forwards`;

        c.innerHTML = `<div class="title"></div>`;

        c.addEventListener("animationend", () => {
          if (c.isConnected) {
            c.remove();
            this.activeCoupons = Math.max(0, this.activeCoupons - 1);
          }
        });

        c.addEventListener("click", () => {
          this.lastClickedCoupon = c;
          this.onCouponClick(c, codeBox, modal, confettiWrap);
          this.countdown();
        });

        rainfield.appendChild(c);
        this.activeCoupons++;
      };

      this.startRain = () => {
        this.stopRain();
        this.spawnTimer = setInterval(spawnCoupon, SPAWN_INTERVAL_MS);
        for (let i = 0; i < Math.max(2, Math.round(MAX_ACTIVE_COUPONS * 0.4)); i++)
          spawnCoupon();
      };

      this.stopRain = () => {
        if (this.spawnTimer) {
          clearInterval(this.spawnTimer);
          this.spawnTimer = null;
        }
      };

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          modal.classList.remove("show");
          if (this.lastClickedCoupon?.isConnected) {
            this.lastClickedCoupon.remove();
            this.lastClickedCoupon = null;
          }
        }
      });

      window.addEventListener("resize", this.setupRainCanvas);
      this.setupRainCanvas();
      this.startRain();
      this.drawRain();
    },
    createFallingSplash(x, y) {
      const splash = document.createElement("div");
      splash.className = "click-splash";
      splash.style.left = `${x}px`;
      splash.style.top = `${y}px`;
      document.body.appendChild(splash);

      const numDrops = 26;
      for (let i = 0; i < numDrops; i++) {
        const drop = document.createElement("div");
        drop.className = "click-drop";
        drop.style.left = `0px`;
        drop.style.top = `0px`;
        drop.style.animationDelay = `${Math.random() * 0.2}s`;

        const angle = Math.random() * Math.PI * 2;
        const burstDistance = 50 + Math.random() * 80;
        const tx = Math.cos(angle) * burstDistance;
        const ty = Math.sin(angle) * burstDistance;

        const finalY = ty + window.innerHeight - y + (Math.random() * 100);

        drop.style.setProperty("--tx", `${tx}px`);
        drop.style.setProperty("--ty", `${ty}px`);
        drop.style.setProperty("--finalY", `${finalY}px`);

        splash.appendChild(drop);
        setTimeout(() => drop.remove(), 2200);
      }

      setTimeout(() => splash.remove(), 2400);
    },
    triggerScreenRipple() {
      const ripple = document.createElement('div');
      ripple.classList.add('screen-ripple');
      document.body.appendChild(ripple);
      requestAnimationFrame(() => ripple.classList.add('expand'));

      setTimeout(() => ripple.remove(), 1200);
    },
    setupRainCanvas() {
      const rainCanvas = this.rainCanvas;
      const rand = (min, max) => min + Math.random() * (max - min);

      const cw = (rainCanvas.width = window.innerWidth);
      const ch = (rainCanvas.height = window.innerHeight);
      this.cw = cw;
      this.ch = ch;

      const isLite = this.forceLite || this.autoLite;
      const baseDensity = isLite ? 45 : 90;

      this.drops = [];
      const layers = isLite
        ? [{ len: [8, 16], spd: [140, 220], w: [1, 1.6], op: [0.25, 0.45] }]
        : [
          { len: [8, 16], spd: [120, 200], w: [1, 1.5], op: [0.22, 0.4] },
          { len: [14, 26], spd: [180, 320], w: [1, 1.8], op: [0.35, 0.55] },
        ];

      for (let i = 0; i < baseDensity; i++) {
        const L = layers[i % layers.length];
        this.drops.push({
          x: Math.random() * cw,
          y: Math.random() * ch,
          l: rand(L.len[0], L.len[1]),
          s: rand(L.spd[0], L.spd[1]),
          w: rand(L.w[0], L.w[1]),
          o: rand(L.op[0], L.op[1]),
        });
      }
    },

    drawRain() {
      const ctx = this.ctx;
      if (!ctx) return;
      ctx.clearRect(0, 0, this.cw, this.ch);

      ctx.strokeStyle = "rgba(255,255,255,0.75)";
      ctx.lineCap = "round";
      const windX = this.autoLite ? -0.6 : -1.0;

      for (const d of this.drops) {
        ctx.globalAlpha = d.o;
        ctx.lineWidth = d.w;
        ctx.beginPath();
        ctx.moveTo(d.x, d.y);
        ctx.lineTo(d.x + windX * 3, d.y + d.l);
        ctx.stroke();

        d.y += d.s * 0.016;
        d.x += windX * 0.7;

        if (d.y > this.ch + 20 || d.x < -20) {
          d.y = -10;
          d.x = Math.random() * this.cw;
        }
      }

      this.rafId = requestAnimationFrame(() => this.drawRain());
    },

    onCouponClick(el, codeBox, modal, confettiWrap) {
      if (this.isClicked) return;

      this.vibrate(2);

      this.isClicked = true;

      el.classList.add("frozen", "glow");
      el.style.pointerEvents = "none";
      this.sendGtag(0)
      this.triggerScreenRipple();

      this.createWaterFountain(el);
      this.showFlyingText("KETANGKEP!!");

      this.stopRain();

      setTimeout(() => {
        this.revealCode(this.code, codeBox, modal, confettiWrap);
        el.style.display = "none"
      }, 1000);

    },
    showFlyingText(text) {
      const flying = document.createElement("div");
      flying.className = "flying-text";
      flying.textContent = text;
      document.body.appendChild(flying);

      setTimeout(() => {
        flying.remove();
      }, 1800);
    },

    createWaterFountain(ticketEl) {
      if (!ticketEl) return;

      const rect = ticketEl.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;

      const splash = document.createElement("div");
      splash.className = "ticket-splash";
      splash.style.left = `${x}px`;
      splash.style.top = `${y}px`;
      document.body.appendChild(splash);

      const numDrops = 45;
      for (let i = 0; i < numDrops; i++) {
        const drop = document.createElement("div");
        drop.className = "ticket-drop";

        drop.style.animationDelay = `${Math.random() * 0.15}s`;

        const angle = Math.random() * Math.PI * 2;
        const burstDistance = 120 + Math.random() * 140;
        const tx = Math.cos(angle) * burstDistance;
        const ty = Math.sin(angle) * burstDistance;

        drop.style.setProperty("--tx", `${tx}px`);
        drop.style.setProperty("--ty", `${ty}px`);
        splash.appendChild(drop);

        setTimeout(() => drop.remove(), 1800);
      }

      setTimeout(() => splash.remove(), 2000);
    },
    revealCode(code, codeBox, modal, confettiWrap) {
      codeBox.textContent = code;
      modal.classList.add("show");
      this.confetti(confettiWrap, 80);
      try {
        navigator.clipboard.writeText(code);
      } catch (err) {
        console.log("Clipboard error:", err);
      }
    },

    confetti(container, n = 60) {
      const colors = [
        "#ff1e56",
        "#ffd319",
        "#00d084",
        "#18a0fb",
        "#7c3aed",
        "#10b981",
      ];
      const vw = window.innerWidth;
      for (let i = 0; i < n; i++) {
        const p = document.createElement("div");
        p.className = "piece";
        p.style.left = Math.random() * vw + "px";
        p.style.background = colors[Math.floor(Math.random() * colors.length)];
        const dur = 1.2 + Math.random() * 1.2;
        const delay = Math.random() * 0.2;
        p.style.animationDuration = `${dur}s`;
        p.style.animationDelay = `${delay}s`;
        container.appendChild(p);
        setTimeout(() => p.remove(), (dur + delay) * 1000 + 80);
      }
    },
  },
};
</script>
